<template>
	<a-card v-if="showHtml">
		<a-table :columns="columns" :pagination="pagination" :data-source="dataSource" :loading="loading"
			@change="onTableChange">
			<template #titleName="{ record }">
				<a @click="onDetail(record)">{{ record.titleName }}</a>
			</template>
			<template #auditStatus="{ record }">
				<div class="table-row-operations">
					<a @click="onShowStatus(record)">{{ record.auditStatus == 0 ? '待审核' : record.auditStatus == 1 ? '审核通过' : '审核不通过' }}</a>
				</div>
			</template>
		</a-table>
	</a-card>
	<a-card v-else>
		<div style="float: right;">
			<div class="table-toolbar">
				<a-button type="primary" @click="onBack"> 返回</a-button>
			</div>
		</div>
		<div style="margin-top: 40px;" v-html="content"></div>
	</a-card>
	<AddOrEditModal ref="modal" :form-primary-key-field="listKeyField" />
</template>

<script>
import AddOrEditModal from "./components/AddOrEditModal";
import { tableListMixin } from "@/mixins";
import { talentSubsidyArticlesInfo } from "@/api/educationService";

const columns = [
	{ title: "标题", dataIndex: "titleName", key: "titleName", slots: { customRender: "titleName" } },
	{ title: "摘要", dataIndex: "abstractNote", key: "abstractNote" },
	{ title: "发布时间", dataIndex: "createdTime", key: "createdTime" },
	{ title: "申请状态", dataIndex: "auditStatus", key: "auditStatus", slots: { customRender: "auditStatus" } }
];
export default {
	name: "index",
	mixins: [tableListMixin],
	components: {
		AddOrEditModal
	},
	data() {
		return {
			columns,
			queryParam: {},
			listUrl: talentSubsidyArticlesInfo.pageList,
			listKeyField: "id",
			content: '',
			showHtml: true,
		}
	},
	methods: {
		onDetail(record) {
			this.getAction({
				url: talentSubsidyArticlesInfo.detail,
				params: { id: record.id }
			}).then(res => {
				this.showHtml = !this.showHtml;
				this.content = res.content
			})
		},
		onBack(){
			this.showHtml = !this.showHtml;
		},
		onShowStatus(record){
			this.getAction({
				url: talentSubsidyArticlesInfo.detail,
				params: { id: record.id }
			}).then(res => {
				this.onShowModal('modal', res);
			})
		}
	}
}
</script>

<style scoped></style>
